(ns ycweb.app.website.school.module.detail
  (:require
   [rum.core :as rum]
   [ycweb.app.website.school.common :as school.common]
   [ycweb.app.website.website :as website]
   [ycweb.components.buttons :as buttons]
   [ycweb.components.common :as cmn]
   [ycweb.components.flow :as flow]
   [ycweb.components.forms :as input-forms]
   [ycweb.components.grid :as grid]
   [ycweb.components.headings :as headings]
   [ycweb.components.toaster :as toaster]
   [ycweb.components.transitions :as t]
   [ycweb.util.comms :as comms]
   [ycweb.util.core :as u]
   [ycweb.util.urlstate :as urlstate]))

(rum/defc course-module < rum/reactive [app-atom]
  (let [state-atom (cmn/action-cursor app-atom)
        module (cmn/curact state-atom [:module])
        {:module/keys [course-title position description course-uuid user-module-uuid notes videos quizzes]} module
        {:ent/keys [display-name]} module]

    [:main
     {:id "main-content" :class (u/bem :yc-page-content [:medium])}
     [:div
      {:class (u/bem :yc-section [:medium-underline])}
      [:div.u-block-center.u-max-width-720
       [:ul.breadcrumbs.group
        [:li.breadcrumbs__item
         [:a.breadcrumb__link
          (urlstate/href-props app-atom "cooking-school" "my-courses" {})
          "My Courses"]]
        [:li
         {:class (u/bem :breadcrumbs__item [:always-show])}
         [:a.breadcrumb__link
          (urlstate/href-props app-atom "cooking-school" "mycourseview" {:uuid course-uuid})
          course-title]]
        [:li.breadcrumbs__item
         [:span.breadcrumb__current-text (str "Lesson " position ": " display-name)]]]
       (headings/heading (str "Lesson " position ": " display-name)
         {:type :h1
          :size :large})
       [:p
        {:class (u/bem :yc-paragraph [:flush])}
        description]]]

     (map
       (fn [[uuid {:section/keys [description items]}]]
         [:div
          {:class (u/bem :yc-section [:medium-underline])}
          (headings/heading description
            {:type :h2
             :size :medium
             :dangerouslySetInnerHTML? true
             :center true})
          (map
            (fn [{:item/keys [vimeo-key]}]
              [:div
               {:class (u/bem :video-wrapper [:medium])}
               [:div
                {:class (u/bem :responsive-iframe-wrapper [:16x9])}
                [:iframe
                 {:src (str "https://player.vimeo.com/video/" vimeo-key)
                  :style {:width "100%"}
                  :frameborder "0"
                  :webkitallowfullscreen ""
                  :mozallowfullscreen ""
                  :allowfullscreen ""}]]])
            items)

          [:div.u-block-center.u-max-width-720.u-margin-top-20
           [:label
            {:for (str "section-" uuid) :class (u/bem :toggle-label [:left])}
            [:input.toggle
             (merge
               (input-forms/checkbox-props
                 (rum/cursor-in state-atom [:module :module/videos uuid :section/completed?])
                 #(grid/dispatch-action app-atom :web.cooking-school/section-save
                    {:uuid uuid :sectionType :module/videos :user-module-uuid user-module-uuid})
                 nil
                 false
                 false)
               {:id (str "section-" uuid)})]
            [:span.toggle__text
             [:span.toggle__title.u-text-right
              "I've watched the video tutorial"]]
            [:span.toggle__graphic-wrapper [:span.toggle__graphic]]]]])
       videos)

     (map
       (fn [[uuid {:ent/keys [display-name] :section/keys [description items]}]]
         [:div
          {:class (u/bem :yc-section [:medium-underline])}
          (headings/heading description
            {:type :h2
             :size :medium
             :dangerouslySetInnerHTML? true
             :center true})

          (map
            (fn [item]
              [:div
               {:class (u/bem :yc-section [:standard])}
               (school.common/lesson-item-card app-atom item)])
            items)

          [:div.u-block-center.u-max-width-720.u-margin-top-20
           [:label
            {:for (str "section-" uuid) :class (u/bem :toggle-label [:left])}
            [:input.toggle
             (merge
               (input-forms/checkbox-props
                 (rum/cursor-in state-atom [:module :module/notes uuid :section/completed?])
                 #(grid/dispatch-action app-atom :web.cooking-school/section-save
                    {:uuid uuid :sectionType :module/notes :user-module-uuid user-module-uuid})
                 nil
                 false
                 false)
               {:id (str "section-" uuid)})]
            [:span.toggle__text
             [:span.toggle__title.u-text-right
              (str "I've completed " display-name)]]
            [:span.toggle__graphic-wrapper [:span.toggle__graphic]]]]])
       notes)

     (map
       (fn [{:ent/keys [uuid]
             :quiz/keys [description status score]}]
         (let [score (or score 0)]
           [:div
            {:class (u/bem :yc-section [:large])}
            [:div.cta-block.u-block-center.u-max-width-480
             (headings/heading description
               {:type :h2
                :size :medium
                :dangerouslySetInnerHTML? true
                :center true})

             (cond
               (and (= status 1) (> score 0))
               [:p.yc-paragraph.u-text-center
                "Quiz completed. You scored " score "%"]

               (> score 0)
               [:p.yc-paragraph.u-text-center
                "Your best quiz score is " score "%. You need to score at least 80% to complete this step."]

               :else
               [:p.yc-paragraph.u-text-center
                "One last step before you move on. Go on, ace the quiz! You need to score at least 80% to complete this step."])

             [:div.u-block-center.u-max-width-240
              (buttons/button-web (if (and (= status "Complete") (> score 0)) "Retake the Quiz" "Start the Quiz")
                (merge
                  (urlstate/href-props app-atom "cooking-school" "quizview" {:uuid uuid})
                  {:type :button
                   :style :primary
                   :size :default
                   :full true}))]]]))
       quizzes)

     (toaster/loading-overlay app-atom :web.cooking-school/module)]))

(defmethod flow/render-screen :web.cooking-school/moduleview [app-atom _]
  (website/screen-wrapper app-atom
    (course-module app-atom)
    {:pagetype :school}))

(defmethod t/transition-open :web.cooking-school/moduleview [app-atom _ params]
  (toaster/open-overlay app-atom :web.cooking-school/module)
  (swap! (cmn/action-cursor app-atom) assoc :module nil)
  (comms/ajax-get :web.cooking-school/moduleview {:ent/uuid (:uuid params)}))

(defmethod comms/receive :web.cooking-school/moduleview [app-atom e]
  (toaster/close-overlay app-atom :web.cooking-school/module)
  (swap!
    (cmn/action-cursor app-atom) assoc
    :module (:module e)))

(defmethod grid/action :web.cooking-school/section-save [app-atom config _]
  (let [state-atom (cmn/action-cursor app-atom)
        completed? (rum/cursor-in state-atom [:module (:sectionType config) (:uuid config) :section/completed?])]
    (toaster/open-toast app-atom :processing "Saving" {:closetime 10000})

    (comms/ajax-post :web.cooking-school/section-save
      {:module
       {:module/user-module-uuid (:user-module-uuid config)
        :module/section
        {:ent/uuid (:uuid config)
         :section/completed? @completed?}}})))

(defmethod comms/receive :web.cooking-school/section-save [app-atom e]
  (toaster/close-toast app-atom)
  (toaster/open-toast app-atom :success "Saved" {:closetime 2000}))

